import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-feeds-blogs-list-card',
  templateUrl: './feeds-blogs-list-card.component.html',
  styleUrls: ['./feeds-blogs-list-card.component.scss'],
})
export class FeedsBlogsListCardComponent implements OnInit{
  @Input() blog;

  ngOnInit(): void {
    // console.log(this.blog)
  }

}
